export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-atendimento-enfermagem' */ '@/views/ambulatorio/atendimento-enfermagem/Index'),
        path: 'atendimento-enfermagem',
        redirect: 'atendimento-enfermagem/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-atendimento-enfermagem' */'@/views/ambulatorio/atendimento-enfermagem/List.vue'),
                name: 'ambulatorio-atendimento-enfermagem-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-atendimento-enfermagem' */ '@/views/ambulatorio/atendimento-enfermagem/Form.vue'),
                name: 'ambulatorio-atendimento-enfermagem-create',
                path: 'create/:tipoAtendimento/:filaId/:agendamentoId?',
                props: route => ({
                    tipoAtendimento: route.params.tipoAtendimento,
                    filaId: parseInt(route.params.filaId),
                    agendamentoId: route.params.agendamentoId ? parseInt(route.params.agendamentoId) : null,
                }),
            },
        ],
    },
]